import { GridFields } from 'components';
import { formatToDateTime } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Input, Stack, Typography } from 'libs/ui';
import { useFormContext } from 'modules/order/order/forms/orderForm';
import { useOrderContext } from 'modules/order/order/providers/OrderProvider';

export const OrderStatusesHistory = () => {
  const { t } = useTranslation();
  const { order } = useOrderContext();

  const { readOnly } = useFormContext();
  const disabled = !readOnly;

  return order.statusesHistory?.map((status) => (
    <Stack key={status.id} spacing={12}>
      <Typography variant="bodyBold">
        {t(`order.status.${status.value}`)}
      </Typography>
      <GridFields>
        {status.reason && (
          <Input
            fullWidth
            readOnly
            showCopyButton
            disabled={disabled}
            label={t(
              'order.sections.executionHistorySection.statusesHistory.fields.reason.label'
            )}
            value={status.reason}
          />
        )}
        <Input
          fullWidth
          readOnly
          showCopyButton
          disabled={disabled}
          label={t(
            'order.sections.executionHistorySection.statusesHistory.fields.employee.label'
          )}
          value={status.employee.name}
        />

        <Input
          fullWidth
          readOnly
          showCopyButton
          disabled={disabled}
          label={t(
            'order.sections.executionHistorySection.statusesHistory.fields.date.label'
          )}
          value={formatToDateTime(status.createdAt)}
        />
      </GridFields>
    </Stack>
  ));
};
